/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MonitEntityPastebinOrderBy = {
    PastebinKey: 'pastebin_key',
    PastebinUrl: 'pastebin_url',
    PastebinMeta: 'pastebin_meta',
    PastebinHighlight: 'pastebin_highlight',
    Found: 'found',
    Created: 'created',
    Updated: 'updated'
} as const;
export type MonitEntityPastebinOrderBy = typeof MonitEntityPastebinOrderBy[keyof typeof MonitEntityPastebinOrderBy];


export function MonitEntityPastebinOrderByFromJSON(json: any): MonitEntityPastebinOrderBy {
    return MonitEntityPastebinOrderByFromJSONTyped(json, false);
}

export function MonitEntityPastebinOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityPastebinOrderBy {
    return json as MonitEntityPastebinOrderBy;
}

export function MonitEntityPastebinOrderByToJSON(value?: MonitEntityPastebinOrderBy | null): any {
    return value as any;
}

